import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import styles from "./styles.module.css";
import PersonIcon from "@mui/icons-material/Person";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import PaperComponent from "../../components/PaperComponent";
import {
  obterUsuarios,
  obterUsuariosPorTextoDeBusca,
  cadastrarUsuario,
  atualizarUsuario,
  excluirUsuario,
} from "../../services/usuarios.service";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import UsuarioForm from "src/forms/UsuarioForm";

const Usuarios = () => {

  const navigate = useNavigate();

  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [editRowData, setEditRowData] = useState({});
  const [msg, setMsg] = useState("");

  const [usersData, setUsersData] = useState([]);
  const [userPermissionsData, setUserPermissionsData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openDialogExclusao, setOpenDialogExclusao] = useState(false);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);

  const columns = [
    { id: "idUsuario", label: "ID", field: "idUsuario" },
    { id: "login", label: "Login", field: "login" },
    { id: "nomeCompleto", label: "Nome", field: "nomeCompleto" },
    { id: "email", label: "E-mail", field: "email" },
    { id: "dtExpiracao", label: "Dt. Expiração", field: "dtExpiracao" },
    { id: "ativo", label: "Ativo", field: "ativo" },
  ];

  const handleOpenModal = async (rowData) => {
    (rowData.idUsuario !== undefined)
      ? setEditRowData(rowData)
      : setEditRowData({});

    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveChanges = async (data) => {
    setLoading(true);

    if (!editRowData.idUsuario) {
      await cadastrarUsuario({usuario: data.usuario})
        .then(async (response) => {
          setMsg(response.mensagem);
          // await atualizarPermissoesUsuario(response.idUsuario, {permissoes: data.permissoes});
          await getUsers();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) => handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout));
    } else {
      delete data.usuario.senha;
      await atualizarUsuario(editRowData.idUsuario, {usuario: data.usuario})
        .then(async (response) => {
          setMsg(response.mensagem);
          // await atualizarPermissoesUsuario(editRowData.idUsuario, {permissoes: data.permissoes});
          await getUsers();
          handleCloseModal();
          handleOpenSnackbarSucesso();
        })
        .catch((err) => handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout));
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    setLoading(true);
    handleCloseDialogExclusao();
    await excluirUsuario(editRowData.idUsuario)
      .then(async (response) => {
        setMsg(response.mensagem);
        await getUsers();
        handleOpenSnackbarSucesso();
      })
      .catch((err) => handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout));
    setLoading(false);
  };

  const getUsers = async () => {
    try {
      const response = await obterUsuarios();
      var usuarios = response.usuarios;
      usuarios.forEach(usuario => {
        usuario.dtExpiracao = new Date(usuario.dtExpiracao)
      });
      setUsersData(usuarios);
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getUsers();
      setLoading(false);
    };

    fetchData();

  }, [navigate]);

  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleClickOpenDialogExclusao = (rowData) => {
    setEditRowData(rowData);
    setOpenDialogExclusao(true);
  };

  const handleCloseDialogExclusao = () => {
    setOpenDialogExclusao(false);
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await obterUsuariosPorTextoDeBusca(event.target.value);
      const usuarios = response.usuarios;
      usuarios.forEach(usuario => {
        usuario.dtExpiracao = new Date(usuario.dtExpiracao)
      });
      setUsersData(response.usuarios);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setUsersData([]);
      } 
      else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      };
    }
    setLoading(false);
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <PersonIcon fontSize="30px"/>
        }
        headerTitle={"Usuários"}
        handleDebounceChange={handleDebouncerChange}
        handleOpenModal={handleOpenModal}
        modalButtonLabel={"Novo"}
      />

      <TabelaDinamica
        data={usersData}
        columns={columns}
        loading={loading}
        orderColumn={'idUsuario'}
        onEditButtonClick={handleOpenModal}
        onDeleteButtonClick={handleClickOpenDialogExclusao}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          style: {
            width: "140%", // Defina a largura desejada
            height: "100vh",
          },
        }}
        maxWidth="lg" // Defina o tamanho máximo do modal
      >
        <DialogTitle className={styles.popupHeader}>
          <div className={styles.linhaTituloPopup} />
          <div className={styles.tituloPopupContainer}>
            <PersonIcon className={styles.iconeTituloPopup} />
            <h1 className={styles.tituloPopup}>
              {editRowData.idUsuario
                ? "Edição de Usuário"
                : "Cadastro de Usuário"}
            </h1>
          </div>
        </DialogTitle>
        <UsuarioForm
          userValues={Object.assign({}, editRowData)}
          // userPermissionData={userPermissionsData}
          // userPermissionValues={[...editRowPermissionsData]}
          // loading={loading}
          onSubmit={handleSaveChanges}
          onClose={handleCloseModal}
          className={styles.popupContent}
        >
        </UsuarioForm>
      </Dialog>

      {/* Dialog de exclusão */}
      <Dialog
        open={openDialogExclusao}
        onClose={handleCloseDialogExclusao}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          className={styles.tituloExclusao}
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          Atenção!
        </DialogTitle>
        <DialogContent>
          <DialogContentText className={styles.textoExclusao}>
            Você realmente deseja excluir permanentemente o usuário {editRowData.login}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={styles.botaoPopupCancelarExclusao}
            autoFocus
            onClick={handleCloseDialogExclusao}
          >
            Cancelar
          </Button>
          <Button className={styles.botaoPopupExcluir} onClick={handleDelete}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default Usuarios;
